export default "__VITE_ASSET__DBRWRK56__"